"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCeramic = exports.CeramicProvider = exports.CeramicContext = void 0;
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const ceramic_service_1 = require("./ceramic-service");
exports.CeramicContext = react_1.default.createContext(null);
function CeramicProvider(props) {
    const service = props.service ||
        new ceramic_service_1.CeramicService(props.network, props.endpoint, props.connect);
    const renderBody = () => {
        if (props.render) {
            return props.render(service);
        }
        else {
            return props.children;
        }
    };
    return (react_1.default.createElement(exports.CeramicContext.Provider, { value: service }, renderBody()));
}
exports.CeramicProvider = CeramicProvider;
function useCeramic() {
    const service = (0, react_1.useContext)(exports.CeramicContext);
    if (service) {
        return service;
    }
    else {
        throw new Error(`Please wrap with CeramicProvider`);
    }
}
exports.useCeramic = useCeramic;
//# sourceMappingURL=use-ceramic.js.map